export const initializeCategoriesMenu = () => {
  const menu = document.querySelector('.categories-menu');

  if (menu) {
    categoriesMenu(menu);
  }
}

const categoriesMenu = (source) => {
  if (typeof source === 'string') {
    source = document.querySelector(source);
  }

  // we need to ensure that we listen this event for older browsers that use prefixes
  var callbacks = ['webkitAnimationEnd', 'oanimationend', 'oAnimationEnd', 'msAnimationEnd', 'animationend'];

  // we will do some matchMedia checks, because we need to do this only
  // in desktop version, and then revert back on mobile/tablet devices
  const mql = window.matchMedia('(min-width: 1024px)');
  mql.addListener(handleDevice);
  // we will by default to a resetNavigation call, because with turbolinks we need
  // to make sure that we don't re-add elements, so we clean it before
  resetNavigation();
  handleDevice(mql);

  function handleDevice(e) {
    if (e.matches) {
      setupNavigation();
    } else {
      resetNavigation();
    }
  }

  function setupNavigation() {
    var showMoreList = source.querySelectorAll('.sub-category-more');
    showMoreList.forEach(function (showMore) {
      showMore.addEventListener('click', navigateCategory);
    });
  }

  function navigateCategory(event) {
    var button = event.target;
    var list = button.closest('.subcategories-list');
    var location = list.closest('.category-container');
    var categoryList = location.querySelector('.category-list-container');

    var optionsContainer = document.createElement('div');
    optionsContainer.classList.add('category-options');

    // now we create the top row to display the title and allow us to go back
    var backButton = document.createElement('button');
    backButton.classList.add('back-to-list');
    backButton.innerText = source.dataset.categoriesMenuBack || 'back to list';
    backButton.addEventListener('click', dismissListing);
    optionsContainer.appendChild(backButton);

    // prepare the categories list to display
    var categoriesContainer = document.createElement('div');
    categoriesContainer.classList.add('category-list');
    optionsContainer.appendChild(categoriesContainer);
    optionsContainer.classList.add('animated', 'fadeInRight');

    var categories = list.querySelectorAll('.sub-category-p');
    categories.forEach(function (category) {
      var clone = category.cloneNode(true);
      clone.style.display = 'block';
      categoriesContainer.appendChild(clone);
    });
    location.appendChild(optionsContainer);

    categoryList.classList.remove('fadeInLeft');
    categoryList.classList.add('animated', 'fadeOutLeft');

    // if our location is bigger than the category list offsetTop we will wait 1s (animation timing)
    // and then smoothly scroll to the top of the category list
    if (location.offsetTop < window.scrollY) {
      setTimeout(function () {
        window.scrollTo({ top: location.offsetTop, behavior: 'smooth' });
      }, 500);
    }
  }

  function dismissListing(event) {
    var target = event.currentTarget;
    var container = target.closest('.category-options');
    container.classList.remove('fadeInRight');
    container.classList.add('fadeOutRight');

    callbacks.forEach(function (callback) {
      container.addEventListener(callback, removeOptionsContainer);
    });

    var list = container.previousSibling;
    list.classList.remove('fadeOutLeft');
    list.classList.add('fadeInLeft');

    // we will also remove the animation of the main container because we don't want it to
    // randomly animate when we close the menu
    callbacks.forEach(function (callback) {
      list.addEventListener(callback, resetListContainer);
    });
  }

  function removeOptionsContainer(event) {
    event.target.remove();
  }

  function resetListContainer(event) {
    var target = event.target;
    target.classList.remove('animated', 'fadeInLeft', 'fadeOutLeft');
    callbacks.forEach(function (callback) {
      target.removeEventListener(callback, resetListContainer);
    });
  }

  function resetNavigation() {
    // basically here we will get any `.category-options` element and remove them, then we do
    // a reset to any `.category-list-container`, we remove the button to see more and show any hidden
    // category
    var options = source.querySelectorAll('.category-options');
    options.forEach(function (option) {
      option.remove();
    });

    var listContainer = source.querySelectorAll('.category-list-container');
    listContainer.forEach(function (element) {
      element.classList.remove('animated', 'fadeInLeft', 'fadeOutLeft');
    });

  }
};